// src/components/CookieConsent.js
import React, { useEffect, useState } from "react";
import "./CookieConsent.css";
import { Link } from 'react-router-dom'; 


const GA_MEASUREMENT_ID = "G-XXXXXXXXXX"; // 👉 Replace with your GA4 ID

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      setVisible(true);
    } else if (consent === "accepted") {
      loadGoogleAnalytics();
    }
  }, []);

  const loadGoogleAnalytics = () => {
    if (window.gtag) return; // already loaded

    // Inject GA script
    const script1 = document.createElement("script");
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_MEASUREMENT_ID}');
    `;
    document.head.appendChild(script2);
  };

  const acceptCookies = () => {
    localStorage.setItem("cookie_consent", "accepted");
    loadGoogleAnalytics();
    setVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookie_consent", "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <p>
        This website uses cookies for analytics to improve your experience.
        You can accept or decline the use of non-essential cookies. For more information, please review{" "}
        <Link to="/privacy" className="cookie-privacy-link">
            Privacy Policy.
        </Link>
      </p>
      <div className="cookie-buttons">
        <button className="btn accept" onClick={acceptCookies}>
          Accept
        </button>
        <button className="btn decline" onClick={declineCookies}>
          Decline
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
